export default __webpack_public_path__ + "b988f0475e93252627fee897007d66f6.png";